import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leadconnector-auth-complete',
  templateUrl: './leadconnector-auth-complete.component.html',
  standalone: false
})

export class LeadConnectorAuthCompleteComponent implements OnInit {
  ngOnInit(): void {
    window.close();
  }

}
